import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { useEffect, useState } from "react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/autoplay";
import { Navigation, Pagination, Autoplay, Scrollbar } from "swiper/modules";
import PureCounter from "@srexi/purecounterjs";
import { getFirestore, collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "./../../firebase"; 

export default function Main() {
  useEffect(() => {
    new PureCounter();
  }, []);
  //const db = getFirestore(app);
  const [successMessage, setSuccessMessage] = useState("");
  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, email, subject, message } = e.target;

    try {
      await addDoc(collection(db, "contacts"), {
        name: name.value,
        email: email.value,
        subject: subject.value,
        message: message.value,
        createdAt: serverTimestamp(),
      });
      setSuccessMessage("Thank you for reaching out! Your message has been successfully sent. We will get back to you shortly.");
      e.target.reset();
    } catch (error) {
      console.error("Error submitting form: ", error);
      alert("Failed to send. Try again.");
    }
  };

  return (
    //  <!-- Hero Section -->
    <main className="main">
      <section
        id="hero"
        className="hero section call-to-action position-relative"
      >
        <div className="container" data-aos="fade-up" data-aos-delay="100">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div
                className="hero-content"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <div className="company-badge mb-5">
                  <i className="bi bi-gear-fill me-2"></i>
                  We are working for your success
                </div>

                <h1 className="mb-4">
                  Tech Solutions <br />
                  to drive your <br />
                  <span className="accent-text">Business Forward</span>
                </h1>

                <p className="mb-4 mb-md-5">
                  From Mobile & Web Applications to AI-Powered Solutions and
                  Cloud Innovation—we don’t just develop software. We design
                  intelligent, scalable, and seamless digital experiences that
                  empower businesses for sustained growth and success!
                </p>

                <div className="hero-buttons">
                  <a
                    href="#contact"
                    className="btn btn-primary me-0 me-sm-2 mx-1"
                  >
                    Get Started
                  </a>
                  {/* <a
                    href="https://www.youtube.com/watch?v=Y7f98aduVJ8"
                    className="btn btn-link mt-2 mt-sm-0 glightbox"
                  >
                    <i className="bi bi-play-circle me-1"></i>
                    Play Video
                  </a> */}
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div
                className="hero-image"
                data-aos="zoom-out"
                data-aos-delay="300"
              >
                <img
                  src="../illustration-1.png"
                  alt="Illustration of business growth"
                  className="img-fluid"
                />
              </div>
            </div>

            {/* /* <!-- Abstract Background Elements --> */}
            <div className="shape shape-1">
              <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M47.1,-57.1C59.9,-45.6,68.5,-28.9,71.4,-10.9C74.2,7.1,71.3,26.3,61.5,41.1C51.7,55.9,35,66.2,16.9,69.2C-1.3,72.2,-21,67.8,-36.9,57.9C-52.8,48,-64.9,32.6,-69.1,15.1C-73.3,-2.4,-69.5,-22,-59.4,-37.1C-49.3,-52.2,-32.8,-62.9,-15.7,-64.9C1.5,-67,34.3,-68.5,47.1,-57.1Z"
                  transform="translate(100 100)"
                ></path>
              </svg>
            </div>

            <div className="shape shape-2">
              <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M41.3,-49.1C54.4,-39.3,66.6,-27.2,71.1,-12.1C75.6,3,72.4,20.9,63.3,34.4C54.2,47.9,39.2,56.9,23.2,62.3C7.1,67.7,-10,69.4,-24.8,64.1C-39.7,58.8,-52.3,46.5,-60.1,31.5C-67.9,16.4,-70.9,-1.4,-66.3,-16.6C-61.8,-31.8,-49.7,-44.3,-36.3,-54C-22.9,-63.7,-8.2,-70.6,3.6,-75.1C15.4,-79.6,28.2,-58.9,41.3,-49.1Z"
                  transform="translate(100 100)"
                ></path>
              </svg>
            </div>

            {/* <!-- Dot Pattern Groups --> */}
            <div className="dots dots-1">
              <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                <pattern
                  id="dot-pattern"
                  x="0"
                  y="0"
                  width="20"
                  height="20"
                  patternUnits="userSpaceOnUse"
                >
                  <circle cx="2" cy="2" r="2" fill="currentColor"></circle>
                </pattern>
                <rect width="100" height="100" fill="url(#dot-pattern)"></rect>
              </svg>
            </div>

            <div className="dots dots-2">
              <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                <pattern
                  id="dot-pattern-2"
                  x="0"
                  y="0"
                  width="20"
                  height="20"
                  patternUnits="userSpaceOnUse"
                >
                  <circle cx="2" cy="2" r="2" fill="currentColor"></circle>
                </pattern>
                <rect
                  width="100"
                  height="100"
                  fill="url(#dot-pattern-2)"
                ></rect>
              </svg>
            </div>

            <div className="shape shape-3">
              <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M43.3,-57.1C57.4,-46.5,71.1,-32.6,75.3,-16.2C79.5,0.2,74.2,19.1,65.1,35.3C56,51.5,43.1,65,27.4,71.7C11.7,78.4,-6.8,78.3,-23.9,72.4C-41,66.5,-56.7,54.8,-65.4,39.2C-74.1,23.6,-75.8,4,-71.7,-13.2C-67.6,-30.4,-57.7,-45.2,-44.3,-56.1C-30.9,-67,-15.5,-74,0.7,-74.9C16.8,-75.8,33.7,-70.7,43.3,-57.1Z"
                  transform="translate(100 100)"
                ></path>
              </svg>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- /Hero Section --> */}

      {/* <!-- About Section --> */}
      <section id="about" className="about section">
        <div className="container" data-aos="fade-up" data-aos-delay="100">
          <div className="row gy-4 align-items-center justify-content-between">
            <div className="col-xl-6" data-aos="fade-up" data-aos-delay="200">
              <span className="about-meta">MORE ABOUT US</span>
              <h2 className="about-title">
                Empowering Businesses with Scalable Tech
              </h2>
              <p className="about-description">
                We specialize in transforming businesses of all sizes with
                cutting-edge web, mobile, and AI-powered solutions. Our mission
                is to simplify technology, making it accessible and efficient
                for companies ready to grow in the digital world.
              </p>

              <div className="row feature-list-wrapper">
                <div className="col-md-6">
                  <ul className="feature-list">
                    <li>
                      <i className="bi bi-check-circle-fill"></i> Custom Web &
                      Mobile App Development
                    </li>
                    <li>
                      <i className="bi bi-check-circle-fill"></i> AI-Powered
                      Automation & Business Insights
                    </li>
                    <li>
                      <i className="bi bi-check-circle-fill"></i> Scalable,
                      Secure, and Future-Ready Solutions
                    </li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <ul className="feature-list">
                    <li>
                      <i className="bi bi-check-circle-fill"></i> Expert
                      Guidance from Development to Deployment
                    </li>
                    <li>
                      <i className="bi bi-check-circle-fill"></i> Continuous
                      Support & Innovation
                    </li>
                    <li>
                      <i className="bi bi-check-circle-fill"></i> On-Time
                      Delivery & Responsive Support
                    </li>
                  </ul>
                </div>
              </div>

              <div className="info-wrapper">
                <div className="row gy-4">
                  {/* <div className="col-lg-5">
                    <div className="profile d-flex align-items-center gap-3">
                      <img
                        src="../avatar-1.webp"
                        alt="CEO Profile"
                        className="profile-image"
                      />
                      <div>
                        <h4 className="profile-name">Mario Smith</h4>
                        <p className="profile-position">CEO &amp; Founder</p>
                      </div>
                    </div>
                  </div> */}
                  <div className="col-lg-7">
                    <div className="contact-info d-flex align-items-center gap-2">
                      <i className="bi bi-telephone-fill"></i>
                      <div>
                        <p className="contact-label">Call us anytime</p>
                        <p className="contact-number">9095254972</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-5" data-aos="fade-up" data-aos-delay="300">
              <div className="image-wrapper">
                <div
                  className="images position-relative"
                  data-aos="zoom-out"
                  data-aos-delay="400"
                >
                  <img
                    src="../about-5.jpg"
                    alt="Business Meeting"
                    className="img-fluid main-image rounded-4"
                  />
                  <img
                    src="../about-2.jpg"
                    alt="Team Discussion"
                    className="img-fluid small-image rounded-4"
                  />
                </div>
                <div className="experience-badge floating">
                  <span>Industry-Backed Expertise,</span>
                  <p>Focused on Your Growth</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- /About Section --> */}

      {/* <!-- Features Section --> */}
      <section id="features" className="features section">
        {/* <!-- Section Title --> */}
        <div className="container section-title" data-aos="fade-up">
          <h2>Features</h2>
          <p>
            Innovation meets reliability—our technology is built to scale,
            powered by AI, and secured for the future.
          </p>
        </div>

        <div className="container">
          <div className="d-flex justify-content-center">
            <ul
              className="nav nav-tabs"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <li className="nav-item">
                <a
                  href="#features-tab-1"
                  className="nav-link active show"
                  data-bs-toggle="tab"
                  data-bs-target="#features-tab-1"
                >
                  <h4>Built to Grow</h4>
                </a>
              </li>

              <li className="nav-item">
                <a
                  href="#features-tab-2"
                  className="nav-link"
                  data-bs-toggle="tab"
                  data-bs-target="#features-tab-2"
                >
                  <h4>Transformative AI</h4>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  data-bs-toggle="tab"
                  data-bs-target="#features-tab-3"
                >
                  <h4>Trust-Driven</h4>
                </a>
              </li>
            </ul>
          </div>

          <div className="tab-content" data-aos="fade-up" data-aos-delay="200">
            <div className="tab-pane fade active show" id="features-tab-1">
              <div className="row">
                <div className="col-lg-6 order-1 text-center">
                  <img
                    src="../features-illustration-1.png"
                    alt=""
                    className="img-fluid"
                  />
                </div>

                <div className="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0 d-flex flex-column justify-content-center">
                  <h3>Scalable Web & Mobile Applications</h3>
                  <p className="fst-italic">
                    We create powerful, flexible, and future-ready web and
                    mobile applications that scale with your business.
                  </p>
                  <ul>
                    <li>
                      <i className="bi bi-check2-all"></i>{" "}
                      <span>
                        Grows with You: Easily expand features and handle more
                        users as your business evolves.
                      </span>
                    </li>
                    <li>
                      <i className="bi bi-check2-all"></i>{" "}
                      <span>
                        Fast & Reliable: Optimized for speed, smooth
                        performance, and a seamless user experience.
                      </span>
                    </li>
                    <li>
                      <i className="bi bi-check2-all"></i>{" "}
                      <span>
                        Secure & Efficient: Built with strong security and
                        efficiency to support long-term success.
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* <!-- End tab content item --> */}

            <div className="tab-pane fade" id="features-tab-2">
              <div className="row">
                <div className="col-lg-6 order-1 order-lg-2 text-center">
                  <img
                    src="../features-illustration-2.jpg"
                    alt=""
                    className="img-fluid"
                  />
                </div>

                <div className="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0 d-flex flex-column justify-content-center">
                  <h3>AI-Powered Solutions</h3>
                  <p className="fst-italic">
                    We integrate AI to automate tasks, improve decision-making,
                    and enhance customer experiences.
                  </p>
                  <ul>
                    <li>
                      <i className="bi bi-check2-all"></i>{" "}
                      <span>
                        Boost Efficiency: Automate repetitive tasks, saving time
                        and reducing manual effort.
                      </span>
                    </li>
                    <li>
                      <i className="bi bi-check2-all"></i>{" "}
                      <span>
                        Smarter Decisions: Use AI-driven insights to make better
                        business choices.
                      </span>
                    </li>
                    <li>
                      <i className="bi bi-check2-all"></i>{" "}
                      <span>
                        Enhanced Customer Experience: Deliver personalized
                        interactions and seamless services.
                      </span>
                    </li>
                    <li>
                      <i className="bi bi-check2-all"></i>{" "}
                      <span>
                        Reliable & Accurate: Ensure high-quality outputs with
                        AI-driven precision and consistency.
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* <!-- End tab content item --> */}

            <div className="tab-pane fade" id="features-tab-3">
              <div className="row">
                <div className="col-lg-6 order-1 text-center">
                  <img
                    src="../features-illustration-3.jpg"
                    alt=""
                    className="img-fluid"
                  />
                </div>

                <div className="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0 d-flex flex-column justify-content-center">
                  <h3>Enterprise-Grade Security</h3>
                  <p className="fst-italic">
                    We prioritize security and reliability to protect your
                    business, ensuring data integrity, compliance, and peace of
                    mind.
                  </p>
                  <ul>
                    <li>
                      <i className="bi bi-check2-all"></i>{" "}
                      <span>
                        Robust Data Protection: Advanced encryption and security
                        frameworks safeguard your sensitive information.
                      </span>
                    </li>
                    <li>
                      <i className="bi bi-check2-all"></i>{" "}
                      <span>
                        Secure by Design: Built with industry-leading security
                        practices to prevent risks and vulnerabilities.
                      </span>
                    </li>
                    <li>
                      <i className="bi bi-check2-all"></i>{" "}
                      <span>
                        Compliance & Reliability: Meets global security
                        standards to ensure trust and long-term protection.
                      </span>
                    </li>
                  </ul>
                  <p className="fst-italic">
                    Continuous monitoring and AI-driven security updates to stay
                    ahead of evolving threats.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- /Features Section --> */}

      {/* <!-- Features Cards Section --> */}
      <section id="features-cards" className="features-cards section">
        <div className="container">
          <div className="row gy-4">
            <div
              className="col-xl-3 col-md-6"
              data-aos="zoom-in"
              data-aos-delay="100"
            >
              <div className="feature-box orange">
                <i className="bi bi-award"></i>
                <h4>Let’s Talk</h4>
                <p>
                  We start with a deep dive into your business needs, goals, and
                  vision. Through a strategic consultation, we identify
                  opportunities and craft a tailored roadmap for success.
                </p>
              </div>
            </div>

            <div
              className="col-xl-3 col-md-6"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="feature-box blue">
                <i className="bi bi-patch-check"></i>
                <h4>We Build</h4>
                <p>
                  Our team designs and develops high-quality web, mobile, and
                  AI-powered solutions, ensuring scalability, security, and
                  seamless user experiences.
                </p>
              </div>
            </div>

            <div
              className="col-xl-3 col-md-6"
              data-aos="zoom-in"
              data-aos-delay="300"
            >
              <div className="feature-box green">
                <i className="bi bi-sunrise"></i>
                <h4>Go Live</h4>
                <p>
                  We launch your solution with rigorous testing, ensuring top
                  performance and high quality, while minimizing downtime for a
                  seamless experience.
                </p>
              </div>
            </div>

            <div
              className="col-xl-3 col-md-6"
              data-aos="zoom-in"
              data-aos-delay="400"
            >
              <div className="feature-box red">
                <i className="bi bi-shield-check"></i>
                <h4>Stay Ahead</h4>
                <p>
                  Our support extends beyond launch, providing ongoing
                  maintenance, AI-driven enhancements, and proactive
                  optimizations to keep you competitive in the market.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- /Features Cards Section --> */}

      {/* <!-- Features 2 Section --> */}
      {/* <!-- /Features 2 Section --> */}

      {/* <!-- Call To Action Section --> */}
      {/* <!-- /Call To Action Section --> */}

      {/* <!-- Clients Section --> */}
      {/* <!-- /Clients Section --> */}

      {/* <!-- Testimonials Section --> */}
      <section
        id="testimonials"
        className="testimonials section light-background"
      >
        {/* <!-- Section Title --> */}
        <div className="container section-title" data-aos="fade-up">
          <h2>Testimonials</h2>
          <p>
            We’re grateful for the trust our clients place in us. Here’s what they have to say about their journey with Magfrai Software Solutions.
          </p>
        </div>

        <div className="container">
          <div className="row g-5">
            <Swiper
              key={Math.random()} // Forces re-render if needed
              modules={[Navigation, Pagination, Autoplay, Scrollbar]}
              spaceBetween={60}
              slidesPerView={2}
              pagination={{ clickable: true }}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              loop={true}
              loopFillGroupWithBlank={true}
              watchSlidesProgress={true}
              breakpoints={{
                0: {
                  slidesPerView: 1, // 👈 Mobile
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 2, // 👈 Tablet and up
                  spaceBetween: 40,
                },
                1024: {
                  slidesPerView: 2, // Desktop
                  spaceBetween: 60,
                },
              }}
            >
              <SwiperSlide>
                <div
                  className="col-lg-12"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  <div className="testimonial-item">
                    
                    <h3>Sharvesh Matrimony - India</h3>
                    <h4>Co-Founder</h4>
                    <div className="stars">
                      <i className="bi bi-star-fill"></i>
                      <i className="bi bi-star-fill"></i>
                      <i className="bi bi-star-fill"></i>
                      <i className="bi bi-star-fill"></i>
                      <i className="bi bi-star-fill"></i>
                    </div>
                    <p>
                      <i className="bi bi-quote quote-icon-left"></i>
                      <span>
                        Magfrai Software Solutions delivered a seamless matrimony platform that has transformed how our community connects. The web and mobile apps are intuitive, beautifully designed, and reliable. We especially appreciate their attention to detail and responsiveness throughout development.
                      </span>
                      <i className="bi bi-quote quote-icon-right"></i>
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div
                  className="col-lg-12"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  <div className="testimonial-item">
                    <h3>Vivablast - vietnam</h3>
                    <h4>Director</h4>
                    <div className="stars">
                      <i className="bi bi-star-fill"></i>
                      <i className="bi bi-star-fill"></i>
                      <i className="bi bi-star-fill"></i>
                      <i className="bi bi-star-fill"></i>
                      <i className="bi bi-star-fill"></i>
                    </div>
                    <p>
                      <i className="bi bi-quote quote-icon-left"></i>
                      <span>
                        Their team developed a robust inventory management solution that integrates AI-driven stock forecasting and QR code tracking. This has significantly improved our operational efficiency and reduced errors. Magfrai was professional and proactive every step of the way.
                      </span>
                      <i className="bi bi-quote quote-icon-right"></i>
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div
                  className="col-lg-12"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  <div className="testimonial-item">
                    <h3>Sourashtra College - India</h3>
                    <h4>Operation Team</h4>
                    <div className="stars">
                      <i className="bi bi-star-fill"></i>
                      <i className="bi bi-star-fill"></i>
                      <i className="bi bi-star-fill"></i>
                      <i className="bi bi-star-fill"></i>
                      <i className="bi bi-star-fill"></i>
                    </div>
                    <p>
                      <i className="bi bi-quote quote-icon-left"></i>
                      <span>
                        The college admin portal has streamlined our admissions, attendance, and communication processes. Faculty and administrators find it easy to use, and our data management is more secure than ever. We highly recommend Magfrai Software Solutions for education technology projects.
                      </span>
                      <i className="bi bi-quote quote-icon-right"></i>
                    </p>
                  </div>
                </div>
                {/* <!-- End testimonial item --> */}
              </SwiperSlide>
              <SwiperSlide>
                <div
                  className="col-lg-12"
                  data-aos="fade-up"
                  data-aos-delay="400"
                >
                  <div className="testimonial-item">
                    <h3>SevenSea International- India</h3>
                    <h4>CMO</h4>
                    <div className="stars">
                      <i className="bi bi-star-fill"></i>
                      <i className="bi bi-star-fill"></i>
                      <i className="bi bi-star-fill"></i>
                      <i className="bi bi-star-fill"></i>
                      <i className="bi bi-star-fill"></i>
                    </div>
                    <p>
                      <i className="bi bi-quote quote-icon-left"></i>
                      <span>
                        We needed a way to send offers to clients globally through WhatsApp and our website. Magfrai created an elegant, user-friendly platform that perfectly meets our needs. It has increased our reach and saved us countless hours.
                      </span>
                      <i className="bi bi-quote quote-icon-right"></i>
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div
                  className="col-lg-12"
                  data-aos="fade-up"
                  data-aos-delay="400"
                >
                  <div className="testimonial-item">
                    <h3>Real Estate CRM- UAE</h3>
                    <h4>Director</h4>
                    <div className="stars">
                      <i className="bi bi-star-fill"></i>
                      <i className="bi bi-star-fill"></i>
                      <i className="bi bi-star-fill"></i>
                      <i className="bi bi-star-fill"></i>
                      <i className="bi bi-star-fill"></i>
                    </div>
                    <p>
                      <i className="bi bi-quote quote-icon-left"></i>
                      <span>
                        Magfrai built a custom CRM with AI-powered lead scoring and automated follow-ups. It has helped our sales team close deals faster and maintain better relationships with clients. The quality of their work is outstanding.
                      </span>
                      <i className="bi bi-quote quote-icon-right"></i>
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div
                  className="col-lg-12"
                  data-aos="fade-up"
                  data-aos-delay="400"
                >
                  <div className="testimonial-item">
                    <h3>Midway Manufacturing- UK</h3>
                    <h4>CFO</h4>
                    <div className="stars">
                      <i className="bi bi-star-fill"></i>
                      <i className="bi bi-star-fill"></i>
                      <i className="bi bi-star-fill"></i>
                      <i className="bi bi-star-fill"></i>
                      <i className="bi bi-star-fill"></i>
                    </div>
                    <p>
                      <i className="bi bi-quote quote-icon-left"></i>
                      <span>
                        Our organization needed an integrated ERP platform with advanced analytics. Magfrai developed a powerful system that gives us clear visibility across departments and AI-generated insights for better decision-making. The results have been transformative.
                      </span>
                      <i className="bi bi-quote quote-icon-right"></i>
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div
                  className="col-lg-12"
                  data-aos="fade-up"
                  data-aos-delay="400"
                >
                  <div className="testimonial-item">
                    <h3>FreshMart Grocery- India</h3>
                    <h4>Store Manager</h4>
                    <div className="stars">
                      <i className="bi bi-star-fill"></i>
                      <i className="bi bi-star-fill"></i>
                      <i className="bi bi-star-fill"></i>
                      <i className="bi bi-star-fill"></i>
                      <i className="bi bi-star-fill"></i>
                    </div>
                    <p>
                      <i className="bi bi-quote quote-icon-left"></i>
                      <span>
                        The POS solution developed by Magfrai has streamlined our checkout and inventory processes across multiple stores. The implementation was smooth, and the team provided excellent training and support.
                      </span>
                      <i className="bi bi-quote quote-icon-right"></i>
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div
                  className="col-lg-12"
                  data-aos="fade-up"
                  data-aos-delay="400"
                >
                  <div className="testimonial-item">
                    <h3>AI-Powered Customer Support Chatbot- India</h3>
                    <h4>Customer Experience Manager</h4>
                    <div className="stars">
                      <i className="bi bi-star-fill"></i>
                      <i className="bi bi-star-fill"></i>
                      <i className="bi bi-star-fill"></i>
                      <i className="bi bi-star-fill"></i>
                      <i className="bi bi-star-fill"></i>
                    </div>
                    <p>
                      <i className="bi bi-quote quote-icon-left"></i>
                      <span>
                        Magfrai created an AI chatbot that has reduced our support workload by 60%. Customers get instant answers 24/7, and our team can focus on complex inquiries. It’s been a fantastic investment.
                      </span>
                      <i className="bi bi-quote quote-icon-right"></i>
                    </p>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
            <br />
            {/* <!-- End testimonial item --> */}
          </div>
        </div>
      </section>
      {/* <!-- /Testimonials Section --> */}

      {/* <!-- Stats Section --> */}
      {/* <!-- /Stats Section --> */}

      {/* <!-- Faq Section --> */}
      <section className="faq-9 faq section light-background" id="faq">
        <div className="container">
          <div className="row">
            <div className="col-lg-6" data-aos="fade-up">
              <h2 className="faq-title">Why Choose Us</h2>
              <p className="faq-description">
                We go beyond delivering technology—we create solutions that
                drive real impact. With a focus on innovation, security, and
                long-term success, we ensure your business stays ahead in the
                digital era.
              </p>
              <div
                className="faq-arrow d-none d-lg-block"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <svg
                  className="faq-arrow"
                  width="200"
                  height="211"
                  viewBox="0 0 200 211"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M198.804 194.488C189.279 189.596 179.529 185.52 169.407 182.07L169.384 182.049C169.227 181.994 169.07 181.939 168.912 181.884C166.669 181.139 165.906 184.546 167.669 185.615C174.053 189.473 182.761 191.837 189.146 195.695C156.603 195.912 119.781 196.591 91.266 179.049C62.5221 161.368 48.1094 130.695 56.934 98.891C84.5539 98.7247 112.556 84.0176 129.508 62.667C136.396 53.9724 146.193 35.1448 129.773 30.2717C114.292 25.6624 93.7109 41.8875 83.1971 51.3147C70.1109 63.039 59.63 78.433 54.2039 95.0087C52.1221 94.9842 50.0776 94.8683 48.0703 94.6608C30.1803 92.8027 11.2197 83.6338 5.44902 65.1074C-1.88449 41.5699 14.4994 19.0183 27.9202 1.56641C28.6411 0.625793 27.2862 -0.561638 26.5419 0.358501C13.4588 16.4098 -0.221091 34.5242 0.896608 56.5659C1.8218 74.6941 14.221 87.9401 30.4121 94.2058C37.7076 97.0203 45.3454 98.5003 53.0334 98.8449C47.8679 117.532 49.2961 137.487 60.7729 155.283C87.7615 197.081 139.616 201.147 184.786 201.155L174.332 206.827C172.119 208.033 174.345 211.287 176.537 210.105C182.06 207.125 187.582 204.122 193.084 201.144C193.346 201.147 195.161 199.887 195.423 199.868C197.08 198.548 193.084 201.144 195.528 199.81C196.688 199.192 197.846 198.552 199.006 197.935C200.397 197.167 200.007 195.087 198.804 194.488ZM60.8213 88.0427C67.6894 72.648 78.8538 59.1566 92.1207 49.0388C98.8475 43.9065 106.334 39.2953 114.188 36.1439C117.295 34.8947 120.798 33.6609 124.168 33.635C134.365 33.5511 136.354 42.9911 132.638 51.031C120.47 77.4222 86.8639 93.9837 58.0983 94.9666C58.8971 92.6666 59.783 90.3603 60.8213 88.0427Z"
                    fill="currentColor"
                  ></path>
                </svg>
              </div>
            </div>

            <div
              className="col-lg-6 features"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              <div className="container tab-pane">
                <h3>Our Features</h3>
                <p className="fst-italic">
                  We create powerful, flexible, and future-ready web and mobile
                  applications that scale with your business.
                </p>
                <ul>
                  <li>
                    <i className="bi bi-check2-all"></i>{" "}
                    <span>
                      Tailored for You – Every solution is designed to meet your
                      unique business needs.
                    </span>
                  </li>
                  <li>
                    <i className="bi bi-check2-all"></i>{" "}
                    <span>
                      AI-Powered Excellence – Smart automation and insights to
                      enhance efficiency and decision-making.
                    </span>
                  </li>
                  <li>
                    <i className="bi bi-check2-all"></i>{" "}
                    <span>
                      Scalable & Future-Ready – Technology that grows with your
                      business, ensuring lasting value.
                    </span>
                  </li>
                  <li>
                    <i className="bi bi-check2-all"></i>{" "}
                    <span>
                      End-to-End Partnership – From strategy to execution, we’re
                      with you every step of the way.
                    </span>
                  </li>
                  <li>
                    <i className="bi bi-check2-all"></i>{" "}
                    <span>
                      Security & Trust First – Your data and business integrity
                      are our top priorities.
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- /Faq Section --> */}

      {/* <!-- Services Section --> */}
      <section id="services" className="services section light-background">
        {/* <!-- Section Title --> */}
        <div className="container section-title" data-aos="fade-up">
          <h2>Our Services</h2>
          <p>Powering Your Digital Success</p>
        </div>
        {/* <!-- End Section Title --> */}

        <div className="container" data-aos="fade-up" data-aos-delay="100">
          <div className="row g-4">
            <div className="col-lg-6" data-aos="fade-up" data-aos-delay="100">
              <div className="service-card d-flex">
                <div className="icon flex-shrink-0">
                  <i className="bi bi-activity"></i>
                </div>
                <div>
                  <h3>Web & Mobile App Development</h3>
                  <p>
                    We craft stunning, high-performance websites and mobile apps
                    designed for seamless user experiences, scalability, and
                    business growth.
                  </p>
                </div>
              </div>
            </div>
            {/* <!-- End Service Card --> */}

            <div className="col-lg-6" data-aos="fade-up" data-aos-delay="200">
              <div className="service-card d-flex">
                <div className="icon flex-shrink-0">
                  <i className="bi bi-diagram-3"></i>
                </div>
                <div>
                  <h3>AI-Powered Business Automation</h3>
                  <p>
                    Supercharge your business with AI! Automate tasks, boost
                    efficiency, and unlock powerful data-driven insights for
                    smarter decision-making.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" data-aos="fade-up" data-aos-delay="300">
              <div className="service-card d-flex">
                <div className="icon flex-shrink-0">
                  <i className="bi bi-easel"></i>
                </div>
                <div>
                  <h3>Cloud Solutions & Infrastructure</h3>
                  <p>
                    Move faster with cloud-powered solutions! We help you build,
                    migrate, and optimize secure, scalable cloud infrastructures
                    with 24/7 reliability.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-6" data-aos="fade-up" data-aos-delay="400">
              <div className="service-card d-flex">
                <div className="icon flex-shrink-0">
                  <i className="bi bi-clipboard-data"></i>
                </div>
                <div>
                  <h3>Security & Compliance</h3>
                  <p>
                    Stay ahead of threats with top-tier security solutions! From
                    encryption to compliance, we ensure your business stays
                    protected and trusted.
                  </p>
                </div>
              </div>
            </div>
            {/* <!-- End Service Card --> */}
          </div>
        </div>
      </section>
      {/* <!-- /Services Section --> */}

      {/* <!-- Pricing Section --> */}
      {/* <!-- /Pricing Section --> */}

      {/* <!-- Call To Action 2 Section --> */}
      {/* <!-- /Call To Action 2 Section --> */}

      {/* <!-- Contact Section --> */}
      <section id="contact" className="contact section light-background">
        {/* <!-- Section Title --> */}
        <div className="container section-title" data-aos="fade-up">
          <h2>Contact</h2>
          <p>Have a project in mind? Let’s build something great together.</p>
        </div>
        {/* <!-- End Section Title --> */}

        <div className="container" data-aos="fade-up" data-aos-delay="100">
          <div className="row g-4 g-lg-5">
            <div className="col-lg-5">
              <div className="info-box" data-aos="fade-up" data-aos-delay="200">
                <h3>Contact Info</h3>
                <p>
                  We’re just a message away — let’s connect and create impact.
                </p>

                <div
                  className="info-item"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  <div className="icon-box">
                    <i className="bi bi-geo-alt"></i>
                  </div>
                  <div className="content">
                    <h4>Our Location</h4>
                    <p>Remote Company</p>
                  </div>
                </div>

                <div
                  className="info-item"
                  data-aos="fade-up"
                  data-aos-delay="400"
                >
                  <div className="icon-box">
                    <i className="bi bi-telephone"></i>
                  </div>
                  <div className="content">
                    <h4>Phone Number</h4>
                    <p>+91 9095254972</p>
                    <p>+91 8072746951</p>
                  </div>
                </div>

                <div
                  className="info-item"
                  data-aos="fade-up"
                  data-aos-delay="500"
                >
                  <div className="icon-box">
                    <i className="bi bi-envelope"></i>
                  </div>
                  <div className="content">
                    <h4>Email Address</h4>
                    <p>
                      <a
                        href="/cdn-cgi/l/email-protection"
                        className="__cf_email__"
                        data-cfemail="452c2b232a05203d24283529206b262a28"
                      >
                        team.magfrai@gmail.com
                      </a>
                    </p>
                    <p>
                      <a
                        href="/cdn-cgi/l/email-protection"
                        className="__cf_email__"
                        data-cfemail="e1828e8f95808295a18499808c918d84cf828e8c"
                      >
                        hello@magfrai.com
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-7">
              <div
                className="contact-form"
                data-aos="fade-up"
                data-aos-delay="300"
              >
                <h3>Get In Touch</h3>
                <p>Your vision, our expertise — contact us to get started.</p>

                <form
                  onSubmit={handleSubmit}
                  className="php-email-form"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  <div className="row gy-4">
                    <div className="col-md-6">
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        placeholder="Your Name"
                        required
                      />
                    </div>

                    <div className="col-md-6 ">
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        placeholder="Your Email"
                        required
                      />
                    </div>

                    <div className="col-12">
                      <input
                        type="text"
                        className="form-control"
                        name="subject"
                        placeholder="Subject"
                        required=""
                      />
                    </div>

                    <div className="col-12">
                      <textarea
                        className="form-control"
                        name="message"
                        rows="6"
                        placeholder="Message"
                        required
                      ></textarea>
                    </div>

                    <div className="col-12 text-center">
                      <div className="loading">Loading</div>
                      <div className="error-message"></div>
                      <div className="sent-message">
                        Your message has been sent. Thank you!
                      </div>

                      <button type="submit" className="btn">
                        Send Message
                      </button>
                    </div>
                  </div>
                </form>
                {successMessage && (
  <div style={{ 
    marginTop: "15px", 
    padding: "10px", 
    border: "1px solid #4CAF50", 
    color: "#4CAF50", 
    borderRadius: "5px" 
  }}>
    {successMessage}
  </div>
)}
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
